import { useSession } from "next-auth/react";
import useSWR from "swr";
import { fetcher } from "./fetcher";


function useUserProfile() {
    const { data: session, status, update }: any = useSession();
    const {
        data: userInfo,
        isValidating,
        mutate,
    } = useSWR(session ? `/api/auth/user?session=${session.user.email}` : null, fetcher, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
    });

    const userProfile: any = userInfo ? [].concat(userInfo.user)[0] : {};
    return [userProfile, isValidating, mutate];
}

export default useUserProfile;